import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { createColumnHelper } from '@tanstack/react-table';
import { getDateFormat, isExpirationDateRisky } from '../../../../utils/date';
import Table from './Table';
import { compareDates } from '../../../../utils/sort';
import moment from '../../../../moment';
import { StudentDataEntry } from '../DashboardTable';

export type DrivingLicenseDataEntry = StudentDataEntry & {
	displayName: string;
	drivingLicenseExpiryDate: string;
};

const columnHelper = createColumnHelper<DrivingLicenseDataEntry>();

const DrivingLicense = ({ students }: { students: DrivingLicenseDataEntry[] }) => {
	const { t } = useTranslation();

	const columns = useMemo(
		() => [
			columnHelper.accessor('displayName', {
				header: t('dashboard.name'),
			}),
			columnHelper.accessor('drivingLicenseExpiryDate', {
				header: t('dashboard.expiry_date'),
				cell: (info) => getDateFormat(info.cell.getValue()),
				sortingFn: (rowA, rowB) =>
					compareDates(
						moment(rowA.original.drivingLicenseExpiryDate),
						moment(rowB.original.drivingLicenseExpiryDate),
					),
			}),
		],
		[],
	);

	const filteredStudents = React.useMemo(() => {
		if (students === null) {
			return [];
		}

		return students.filter(({ drivingLicenseExpiryDate }) =>
			isExpirationDateRisky(drivingLicenseExpiryDate),
		);
	}, [students]);

	return <Table data={filteredStudents} columns={columns} />;
};

export default DrivingLicense;
